import Button from "Components/Button";
import FormInput from "Components/FormInput";
import FormTextArea from "Components/FormTextArea";
import LoadingIcon from "Components/LoadingIcon";
import moment from "moment";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Field, Form } from "react-final-form";
import styled from "styled-components";
import { mobileSize } from "Themes/Metrics";
import { FormError, FormSuccess } from "Themes/StyledComponents";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

const ButtonContainer = styled.div`
  width: 30%;
  float: right;
  @media ${mobileSize.large} {
    width: 100%;
  }
`;

const validate = (values) => {
  const errors = {};
  if (!values.update) {
    errors.update = "Required";
  }
  if (!values.updateDescription) {
    errors.updateDescription = "Required";
  }
  return errors;
};

class UpdateProjectForm extends Component {
  state = {
    project: {},
    update: {},
  };

  componentDidUpdate(prevProps) {
    const { project } = this.props;
    if (prevProps.project !== project) {
      const weekStart = moment().startOf("isoWeek");
      const weekEnd = moment().endOf("isoWeek");
      project.projectUpdates.filter((update) => {
        let momentDate = moment(update.created);
        if (momentDate.isBetween(weekStart, weekEnd)) {
          this.setState({ update });
        } else {
          this.setState({ update: {} });
        }
        return {};
      });
    }
  }

  render() {
    const {
      handleSubmit,
      fetching,
      error,
      success,
      openModal,
      closeModal,
    } = this.props;
    const { update } = this.state;

    const updateCreated = Object.values(update).length > 0;

    const buttonTitle = updateCreated ? "Edit Update" : "Post Update";

    return (
      <>
        <Modal show={openModal} onHide={closeModal}>
          <Modal.Header>
            Update your project - Week beginning (
            {moment()
              .startOf("week")
              .format("DD/MM/YYYY")}
            )
          </Modal.Header>
          <Modal.Body>
            <Form
              onSubmit={handleSubmit}
              validate={validate}
              initialValues={
                updateCreated && {
                  update: update.update,
                  updateDescription: update.updateDetails,
                }
              }
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div>
                    <Field
                      name={"update"}
                      render={(props) => {
                        return (
                          <FormInput
                            {...props}
                            placeholder={
                              "The title of your update (e.g. Website launch)"
                            }
                          />
                        );
                      }}
                    />
                  </div>
                  <div>
                    <Field
                      name={"updateDescription"}
                      render={(props) => {
                        return (
                          <FormTextArea
                            {...props}
                            placeholder={
                              "The description of your update (e.g. We've launched our website!)"
                            }
                          />
                        );
                      }}
                    />
                  </div>
                  {error && <FormError>{error}</FormError>}
                  {success && (
                    <FormSuccess>
                      <IoIosCheckmarkCircleOutline size={20} color={"green"} />{" "}
                      Project updated
                    </FormSuccess>
                  )}
                  <ButtonContainer>
                    <Button type={"submit"} width={"30%"}>
                      {fetching ? <LoadingIcon /> : buttonTitle}
                    </Button>
                  </ButtonContainer>
                </form>
              )}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default UpdateProjectForm;
